<template>
	<div>
		<Affix>
			<div class="header" :style="istop?{'backgroundColor':bgColor[actionPag]}:{'backgroundColor':'#FFFFFF'}">
				<Row type="flex" justify="space-between">
					<Col span="4">
						<span class="navbar-brand" style="padding-left: 10px;">
							<img v-if="istop" class="logo" src="../../assets/logo2.png" />
							<img v-else class="logo" src="../../assets/logo.png" />
						</span>
					</Col>
					<Col span="4" style="text-align: center;padding-top: 4px;" :style="istop?{color:'#ffffff'}:''">
						<Icon @click="openNews = true" size="30" type="md-menu" />
					</Col>
				</Row>
				
			</div>
		</Affix>
		<div class="body">
			<div class="banner" :style="{'backgroundColor':bgColor[actionPag]}"
				style="padding-top: 10px; line-height: 0;">
				<Carousel autoplay loop :autoplay-speed="5000" @on-change="CarouselChange">
					<CarouselItem>
						<div class="container">
							<img src="../../assets/banner1.png" style="width: 100%" />
						</div>
					</CarouselItem>
					<CarouselItem>
						<div class="container">
							<img src="../../assets/banner2.png" style="width: 100%" />
						</div>
					</CarouselItem>
				</Carousel>
			</div>
		</div>
		<div class="container">
			<div style="overflow: hidden;">
				<div class="container">
					<h2 class="section-title">
						核心<span>理念</span>
					</h2>
					<Row :gutter="16" type="flex" justify="center" align="middle">
						<Col @click="cindex=0" :style="cindex==0?[{color:'#FF6633'},{'fontSize':'20px'},{'fontWeight':'500'}]:''">经营理念</Col>
						<Col @click="cindex=1" :style="cindex==1?[{color:'#FF6633'},{'fontSize':'20px'},{'fontWeight':'500'}]:''">核心价值观</Col>
						<Col @click="cindex=2" :style="cindex==2?[{color:'#FF6633'},{'fontSize':'20px'},{'fontWeight':'500'}]:''">公司使命</Col>
						<Col @click="cindex=3" :style="cindex==3?[{color:'#FF6633'},{'fontSize':'20px'},{'fontWeight':'500'}]:''">公司愿景</Col>
					</Row>
					<Carousel autoplay loop v-model="cindex">
					        <CarouselItem>
					            <div class="demo-carousel">
									<div class="htext">阳关创业 永续经营</div>
								</div>
					        </CarouselItem>
					        <CarouselItem>
					            <div class="demo-carousel">
									<div class="mtext">诚信 创新 专业 服务</div>
								</div>
					        </CarouselItem>
					        <CarouselItem>
					            <div class="demo-carousel">
									<div class="htext" style="font-size: 30px;margin-top: 24px;">为伙伴搭建永续的经营平台为大众提供专业的保险服务</div>
								</div>
					        </CarouselItem>
					        <CarouselItem>
					            <div class="demo-carousel">
									<div class="mtext" style="font-size: 30px;margin-top: 24px;">让保险助力<br>亿万家庭幸福生活</div>
								</div>
					        </CarouselItem>
					    </Carousel>
				</div>
				
			</div>
			<h2 class="section-title">
				供应商<span>优势</span>
			</h2>
			<insureList></insureList>
		</div>
		<div class="container" v-if="data2.length>0">
			<h2 class="section-title">
				汇金<span>头条</span>
			</h2>

			<div style="padding: 10px;">
				<Card :bordered="true" v-for="(item,index) in data2" style="margin-bottom: 10px;"  >
					 <p slot="title" @click="goPage(item.id)">
					            <Icon type="ios-square" color="#FF6633"/>
					            {{item.title}}
					        </p>
					<div class="newsBody"><p>{{delHtmlTag(item.body)}}</p> </div>
				</Card>
			</div>
		</div>
		
		<div style="width: 100%;">
			
			<div style="margin-bottom: 40px;">
				<div class="container">
					<h2 class="section-title">
						信息<span>披露</span>
					</h2>
					<div style="padding: 10px;">
						<Card :bordered="true" v-for="(item,index) in data1" style="margin-bottom: 10px;" >
							 <p slot="title" @click="goPage(item.id)">
							            <Icon type="ios-square" color="#FF6633"/>
							            {{item.title}}
							        </p>
							<div class="newsBody"><p>{{delHtmlTag(item.body)}}</p> </div>
						</Card>
					</div>
					
					

				</div>
			</div>
		</div>
		<div style="width: 100%;height: 300px;background-color: #f6f7f9;padding-top: 20px;">
			<Row type="flex" justify="center" align="middle" >
				<Col span="16">
				2022 &copy; 汇金永信保险销售服务有限公司<br>
				地址：四川省成都市高新区府城大道中段88号中航城市广场1205室<br>
				联系方式：028-85224343
				邮件：hjyxcoltd@163.com<br>
				网站版权所有 hjyxbx.com 所有
				Copyright © 2013 蜀ICP备13002380号  
				</Col>
				<Col span="16" style="text-align: center;">
				<img src="../../assets/erweima.jpg" style="width: 100px;margin-top: 10px;" />
				</Col>
			</Row>
		</div>
		<Drawer :width="200" :closable="false" v-model="openNews">
			<List>
				 	<ListItem >
						<router-link to='/m/index'>
						 首页
						</router-link>
				 	</ListItem>
				 	<ListItem>
						<router-link to='/m/us'>
						 关于汇金
						</router-link>
				 	</ListItem>
				 	<ListItem v-for="(item,index) in titleList" :name="item.id"
				 		v-if="item.id<100">
						<router-link :to='"/m/list?id="+item.id'>
				 		{{item.name}}
						</router-link>
				 	</ListItem>
				 	<ListItem >
						<router-link to='/m/map'>
				 		联系我们
						</router-link>
				 	</ListItem>
			 </List>
		</Drawer>
		<BackTop></BackTop>
	</div>
</template>


<script>
	import {
		sendMsg
	} from '../../api/index.js'
	import insureList from "../../components/inusers_mini.vue"
	import moment from 'moment'
	import photos from '../../components/photos.vue'
	export default {
		data() {
			return {
				cindex:0,
				actionPag: 0,
				bgColor: ['#FF6633', '#359af5'],
				istop: true,
				solheight: 0,
				acvtion: "0",
				columns1: [{
						title: '披露信息',
						key: 'title'
					},
					{
						width: 200,
						title: '创建时间',
						key: 'createTime',
						render: (h, dto) => {
							return h('div', [h('span', moment(dto.row.createTime).format('YYYY-MM-DD hh:mm:ss'))])
						},
						sortType: "desc",
						align: "right"
					}
				],
				data1: [],
				data2: [],
				openNews: false,
				showbody: {},
				titleList: [],
				showIndex: 0
			}
		},

		created() {

		},
		mounted() {
			this.initData()
			this.getHotList()
			window.addEventListener('scroll', this.scrollToTop)
		},
		methods: {
			delHtmlTag(str) {
				let tags = str.replace(/<[^>]+>/g, '')
				return tags.replace(/&nbsp;/gi, "")
			},
			delnsp(str) {
				return str.replace("&nbsp;", '')
			},
			getDD(e) {
				return moment(e).format('DD')
			},
			getYYYYMM(e) {
				return moment(e).format('YYYY-MM')
			},
			scrollToTop() {
				var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
				this.solheight = scrollTop
				if (scrollTop > 80) {
					this.istop = false
				} else {
					this.istop = true
				}
			},
			CarouselChange(a, e) {

				this.actionPag = e
			},
			initData() {
				sendMsg("/baseNews/list", {
					limit: 5,
					page: 1,
					type: 5
				}, 'POST', false).then(res => {
					this.data1 = res.data.data
				})

				sendMsg("/baseType/list", {}, "POST", false).then(res => {
					this.titleList = res.data.data
				})
			},
			getHotList() {
				let that = this
				sendMsg("/baseNews/list", {
					limit: 3,
					page: 1,
					isHot: true,
					orderBy: "power"
				}, 'POST', false).then(res => {
					that.data2 = res.data.data
				})
			},
			showTable(e) {
				this.openNews = true
				this.showbody = e
			},
			goPage(e) {
				this.$router.push({
					path: '/m/detal?id=' + e
				})
			},
			goPagehot(e) {
				this.$router.push({
					path: '/news?id=' + e + "&hot=ture"
				})
			}
		},
		components: {
			sendMsg,
			insureList,
			photos
		}
	};
</script>

<style>
	.container {
		width: 100%;
		margin-right: auto;
		margin-left: auto;
		max-width: 1140px;
	}

	.header {
		background-color: transparent;
		padding: 0;
		height: 90px;
		display: grid;
		align-items: center;
	}

	.container__wrapper--center {
		margin: 0 auto;
	}

	.navbar {
		width: 100%;
		position: relative;
		display: flex;
		align-items: center;
	}

	.navbar-expand-lg {
		width: 100%;
		min-width: 992px;
		flex-flow: row nowrap;
		justify-content: flex-start;
	}

	.navbar .navbar-brand {
		margin: 2px 0 0;
		padding: 0;
		font-size: 22px;
		color: #fff;
		font-weight: 800;
		text-transform: uppercase;
	}

	a {
		text-decoration: none;

	}


	a:hover {
		background: linear-gradient(#FF6600, #FF6633);
		color: #FFFFFF !important;
	}

	.logo {
		width: auto;
		height: 40px;
	}

	.navbar-nav {
		display: flex;
		flex-direction: row;
		padding-left: 0;
		margin-bottom: 0;
		list-style: none;
		align-items: center;
		margin-left: auto !important;
		height: 80px;
	}

	.navbar-collapse {
		-ms-flex-preferred-size: 100%;
		flex-basis: 100%;
		-ms-flex-positive: 1;
		flex-grow: 1;
		-ms-flex-align: center;
		align-items: center;
	}

	.navbar-expand-lg .navbar-collapse {
		display: -ms-flexbox !important;
		display: flex !important;
		-ms-flex-preferred-size: auto;
		flex-basis: auto;
	}

	.navbar-nav .nav-item {
		padding: 0 18px;
		transition: all .5s ease;
		position: relative;

	}

	.navbar-nav .nav-item :hover::before {
		position: absolute;
		top: 40px;
		right: calc(50% - 10px);
		width: 20px;
		height: 3px;
		background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFwAAAA+CAMAAACRDYw7AAAAQlBMVEUAAAAAAADyhy35vWP4vGP2qk/0mDz4u2H1okj3rlP1pkv0m0D4t1z1n0T3tFn3sVfzlDnzkTbyii/yjjPyjDHyhyxN587IAAAABXRSTlMAArW1tP5J36kAAACnSURBVFjD7dZbCoMwEIXhamuuJtFo9r/VUgMHH2otysAE5l/ARxhye0iSJElSG3W7iGREQyMSG9HQiMRGJDZii3enscT7kvO6LPM8TUop730Ixhjn3DAM1toUYxxHrZ+X8PLB1yM8pVRxfQ3P31ZebTK86pt9Ay/bVICHEGDfxnssHPhuLJjKi99W/AvnevxPcb5X7m+d9zN3qLfwtYAPWZIkSZKa6A0wZw0kr1ugbQAAAABJRU5ErkJggg==) no-repeat 50%;
		content: "";
		border-radius: 4px;
	}

	.navbar-expand-lg .navbar-nav .nav-link {
		padding: 6px 7px;
		font-size: 16px;
		border-bottom: 1px solid transparent;
		opacity: .8;
		color: #000;
		border-radius: 4px;
	}

	.navbar-expand-lg .navbar-nav .active {}

	.topcolor {
		color: #FFFFFF !important;
	}

	li {
		list-style-type: none;
	}

	.cursor-pointer {
		cursor: pointer;
	}

	.section-title {
		text-align: center;
		position: relative;
		padding: 0 0 15px;
		margin: 20px 0 20px 0;
		padding: 20px 0 15px 0;
		/* font-weight: 600; */
		font-size: 20px;
	}

	.section-title::before {
		bottom: 0;
		width: 60px;
	}

	.section-title::after,
	.section-title::before {
		position: absolute;
		content: "";
		left: 50%;
		height: 1px;
		/* top: 80px; */
		background: #FF6633;
		-webkit-transform: translateX(-50%);
		transform: translateX(-50%);
	}

	.section-title span {
		margin-right: 10px;
		margin-left: 10px;
		color: #FF6633;
	}

	.section-title::after {
		bottom: -5px;
		width: 30px;
	}

	.section-title::after,
	.section-title::before {
		position: absolute;
		content: "";
		left: 50%;
		height: 2px;
		background: #FF6633;
		-webkit-transform: translateX(-50%);
		transform: translateX(-50%);
	}

	*,
	::after,
	::before {
		box-sizing: border-box;
	}

	.itemcricle {
		position: relative;
		top: -50%;
		left: 50%;
		border-radius: 50%;
		width: 1420px;
		height: 1420px;
		background: transparent;
		box-shadow: -24px 0 41px rgba(0, 0, 0, .05);
		border: 172px solid #fff;
	}

	.itemcricle .item {
		position: relative;
		width: 120px;
		height: 120px;
		background-image: linear-gradient(229deg, #fff 0%, #f6f7f9 97%);
		border: .5px solid #e3e3e3;
		border-top-color: rgb(227, 227, 227);
		border-right-color: rgb(227, 227, 227);
		border-bottom-color: rgb(227, 227, 227);
		border-left-color: rgb(227, 227, 227);
		border-radius: 50%;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.itemcricle .active {
		font-size: 18px;
		background: #FF6633;
		color: #fff;
	}

	.space {
		width: 64px;
		height: 12px;
		background: #FF6633;
		border-radius: 1px;
		float: left;

	}

	.hotmain {
		display: flex;
		justify-content: space-between;
		border: 1px solid #d6d6d6d6;
		height: 340px;
		box-shadow: 3px 3px 1px 1px #f6f7f9;
	}

	.hotmain .hotImg {
		float: left;
		height: 340px;
		margin: 0px 0px 0px 0px;
		padding: 0px 0px 0px 0px;
		position: relative;
		width: 550px;
		cursor: pointer;
	}

	.hotmain .item {
		cursor: pointer;
	}

	.hotmain .hotImg img {
		height: 340px;
		width: 550px;
	}

	.hotmain .hotBox {
		float: left;
		height: 338px;
		margin: 0px 0px 0px 0px;
		padding: 0px 0px 0px 0px;
		width: 596px;
		margin-left: 20px;
	}

	.hotmain .divbox {
		float: left;
		font-size: 20px;
		height: 35px;
		line-height: 35px;
		overflow: hidden;
		text-align: left;
		text-overflow: ellipsis;
		text-overflow: ellipsis;
		-ms-text-overflow: ellipsis;
		-o-text-overflow: ellipsis;

		white-space: nowrap;
		width: 517px;
	}

	.divbox::before {
		content: "";
		display: inline-block;
		width: 4px;
		height: 4px;
		vertical-align: middle;
		background-color: #FF6600;
		margin-right: 6px;
	}

	.hotmain .boxdep {
		color: #909090;
		float: left;
		font-size: 14px;
		height: 25px;
		line-height: 25px;
		overflow: hidden;
		text-align: left;
		text-overflow: ellipsis;
		text-overflow: ellipsis;
		-ms-text-overflow: ellipsis;
		-o-text-overflow: ellipsis;
		white-space: nowrap;
		width: 417px;
		margin-top: 4px;
	}

	.hotmain .boxdep::before {
		content: "";
		display: inline-block;
		width: 4px;
		height: 4px;
		vertical-align: middle;
		margin-right: 6px;
	}

	.hotmain .item {
		height: 90px;
		padding: 15px 20px 15px 10px;
		width: 570px;
	}

	.hotmain .bg {
		background-color: #000;
		opacity: 0.6;
		background-repeat: no-repeat;
		background-size: 100% 100%;
		-moz-background-size: 100% 100%;
		color: #ffffff;
		font-size: 22px;
		height: 54px;
		left: 0px;
		line-height: 54px;
		padding: 0px 20px 0px 20px;
		position: absolute;
		top: 285px;
		width: 550px;
		overflow: hidden;
		text-align: left;
		text-overflow: ellipsis;
		text-overflow: ellipsis;
		-ms-text-overflow: ellipsis;
		-o-text-overflow: ellipsis;
	}

	.hotmain .date {
		float: left;
		font-size: 14px;
		height: 25px;
		line-height: 25px;
		text-align: right;
		width: 100px;
	}

	.mtext {
		font: 40px "微软雅黑";
		/*设置字体和字体大小*/
		margin: 50px auto;
		/*设置元素外边距*/
		font-weight: 500;
		/*设置字体粗细*/
		text-align: center;
		/*设置文字居中*/
		color: #f35626;
		/*设置文字颜色*/
		-webkit-animation: swing 2s infinite;
		/*设置动画*/
	}

	@-webkit-keyframes swing {

/* 		20% {
			-webkit-transform: rotate(15deg);
		}

		40% {
			-webkit-transform: rotate(-15deg);
		}

		60% {
			-webkit-transform: rotate(5deg);
		}

		80% {
			-webkit-transform: rotate(-5deg);
		}

		100% {
			-webkit-transform: rotate(0deg);
		} */
	}

	.htext {
		font: 40px "微软雅黑";
		/* 设置字体和字体大小 */
		margin: 50px auto;
		/*设置元素外边距*/
		font-weight: 500;
		/*设置字体粗细*/
		text-align: center;
		/*设置文字居中*/
		color: #f35626;
		/*设置文字颜色*/
		-webkit-animation: bounce 2s infinite;
		/*设置动画*/
	}

	@-webkit-keyframes bounce {

		/*创建动画*/
/* 		0%,
		100%,
		20%,
		50%,
		80% {
			-webkit-transform: translateY(0);
		}

		40% {
			-webkit-transform: translateY(-30px);
		}

		60% {
			-webkit-transform: translateY(-15px);
		} */
	}

	.newBody {
		display: flex;
		justify-content: space-around;
		align-items: center;
		border: 1px solid #d6d6d6d6;
		height: 100px;
		box-shadow: 3px 3px 1px 1px #f6f7f9;
		margin-bottom: 20px;
		cursor: pointer;
	}

	.newBody .timer {
		width: 70px;
		float: left;
	}

	.newBody .timer strong {
		display: block;
		line-height: 50px;
		background-color: #2d8cf0;
		text-align: center;
		font-size: 28px;
		color: #fff;
	}

	.newBody .timer span {
		display: block;
		line-height: 22px;
		text-align: center;
		font-size: 12px;
		color: #fff;
		margin-top: 1px;
		background-color: #ccc;
	}

	.newBody .body {
		width: 92%;
	}

	.newBody .body .title {
		font-weight: 700;
		font-size: 16px;
		height: 35px;
		line-height: 35px;
		overflow: hidden;
		text-align: left;
		text-overflow: ellipsis;
		text-overflow: ellipsis;
		-ms-text-overflow: ellipsis;
		-o-text-overflow: ellipsis;
	}

	.newsBody p {
		position: relative;
		line-height: 20px;
		max-height: 40px;
		overflow: hidden;
	}

	.newsBody p::after {
		content: "...";
		position: absolute;
		bottom: 0;
		right: 0;
		padding-left: 40px;
		background: -webkit-linear-gradient(left, transparent, #fff 55%);
		background: -o-linear-gradient(right, transparent, #fff 55%);
		background: -moz-linear-gradient(right, transparent, #fff 55%);
		background: linear-gradient(to right, transparent, #fff 55%);
	}
	.demo-carousel{
		width: 100%;
		height: 140px;
	}
</style>
